import React from "react";

import Log from "components/Tvendo/Mobile/Log";

export default function () {
  return <Log />;
}
